import _ from 'lodash';
import { UserAnswerFieldsFragment } from '@graphql/user/generated/graphql.types';
import { isBlockContentEmpty } from './isBlockContentEmpty';

export function isAnswerEmpty(answer?: UserAnswerFieldsFragment | null) {
  if (!answer) {
    return true;
  }

  const isBooleanListEmpty =
    !answer.booleanlistValue?.length ||
    answer.booleanlistValue.every((val) => val === false);

  return (
    isBlockContentEmpty(answer.blocklistValue) &&
    _.isNil(answer.booleanValue) &&
    isBooleanListEmpty &&
    _.isNil(answer.numericValue) &&
    !answer.numericlistValue?.length &&
    _.isNil(answer.textValue) &&
    !answer.textlistValue?.length
  );
}
